const replaceUrl = newUrl =>
  history.replaceState(null, null, newUrl + location.hash);

export default replaceUrl;
